var React = require('react');
var moment = require('moment');

var robot = require('../../images/error-robot.png');

var Error = React.createClass({
    render: function () {
        return <div className="standalone-page-wrapper">
            <div className="error-top-block">
              <div className="error-top-block-image"> <img src={robot} alt="Ooops!" /> </div>
            </div>

            <div className="error-bottom-block">
              <div className="col-md-6 col-md-offset-3 error-description">
                <div className="error-code">Uhoh</div>
                <div className="error-meaning">We couldnt authenticate you.</div>
                <div className="todo">
                  <h4>We're not sure that you're you, sorry.</h4>
                  We experienced an error while communicating with our authentication server. Please try again or contact us for assistance.
                </div>
                <div className="copyrights"> &copy; Infinite Networks Pty Ltd {moment().format('YYYY')}</div>
              </div>
            </div>
        </div>;
    }
})
module.exports = Error;



// WEBPACK FOOTER //
// ./app/components/Authentication/Error.js